import React, {useState} from "react"
import {Tooltip} from "reactstrap"

const TooltipItem = ({id, message}) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(v => !v)

  return <>
    <span href="#" id={id}><img src={"/securetravel/images/ico-tooltips.svg"} /></span>
    <Tooltip placement="right" isOpen={isOpen} target={id} toggle={toggle} autohide={false}>
      {message}
    </Tooltip>
  </>
}

export default TooltipItem